/* ij-cart-bar.js — keep the sticky ATC bar present for the WHOLE product page
 * (client 08-11 "Ik wil ook zo'n static knop" + Igor 08-12 "de hele product pagina
 * laten meegaan", Gymshark reference).
 *
 * Broadcast's own cart-bar.js only shows the bar after the page scrolls PAST the buy
 * form (scrollY > formWrapper bottom). We do not fight that toggle: the vendor keeps
 * owning `is-visible`, we toggle a parallel `ij-visible` class whose CSS mirrors it.
 * The bar shows when EITHER class is set. Our rule: bar visible whenever the real
 * add-to-cart button is NOT in the viewport, so there are never two buy buttons on
 * screen and the bar rides along everywhere else, including above the buy area.
 */
(function () {
  'use strict';
  var init = function () {
    var bar = document.querySelector('cart-bar.cart-bar');
    /* NOT `document.querySelector('form[action*="/cart/add"]')`: the FIRST such form on a
     * Broadcast PDP is Shopify's `installment` payment-terms form, which contains no buy
     * button, so a first-match lookup silently finds nothing. Target the button itself,
     * preferring the vendor's own product-form scope, and never the cart-bar's copy. */
    var atc = document.querySelector('[data-product-form] [data-add-to-cart]');
    if (!atc) {
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length && !atc; i++) {
        var b = forms[i].querySelector('[data-add-to-cart], button[name="add"]');
        if (b && !b.closest('cart-bar')) atc = b;
      }
    }
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('ij-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(atc);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
